import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ModalService } from 'src/app/services/modal.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-qr',
  templateUrl: './qr.component.html',
  styleUrl: './qr.component.css'
})
export class QrComponent implements OnInit {
  qrComponentDisplay$!: Observable<'open' | 'close'>;
  constructor(private modalService: ModalService,private storage:StorageService){
    
  }
  ngOnInit(): void {
    this.qrComponentDisplay$ = this.modalService.watchQrComponentDisplay();
  }

  closeQRView() {
    this.modalService.closeQrsDisplay();
  }

  get_qr_content(){
    const user_id = this.storage.getFromLocalStorage("click_user_id")
    const controller_uuid = this.storage.getFromLocalStorage("clicked_user_"+user_id)
    if(user_id){
    const qr_content = this.storage.getFromLocalStorage(controller_uuid+"_qr")
    if(qr_content){
      return qr_content
    }
  }
    return null
  }

  get_qr_controler_uuid(){
    const user_id = this.storage.getFromLocalStorage("click_user_id")
    if(user_id){
      const controller_uuid = this.storage.getFromLocalStorage("clicked_user_"+user_id)
    if(controller_uuid){
      return controller_uuid
    }
  }
    return null
  }
}
